// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-policy__spin {
    margin-left: 12px;
    width: 12px;
    height: 12px;
  }
  .privacy-policy__link {
    display: flex;
    align-items: center;
    margin-top: 12px;
  }
  .privacy-policy .privacy-policy__disabled-link {
    cursor: not-allowed;
    opacity: 0.5;
    text-decoration: none;
  }
`, "",{"version":3,"sources":["webpack://./src/components/Auth/PrivacyPolicy/style.scss"],"names":[],"mappings":"AACE;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;EACvB","sourcesContent":[".privacy-policy {\n  &__spin {\n    margin-left: 12px;\n    width: 12px;\n    height: 12px;\n  }\n\n  &__link {\n    display: flex;\n    align-items: center;\n    margin-top: 12px;\n  }\n\n  & &__disabled-link {\n    cursor: not-allowed;\n    opacity: 0.5;\n    text-decoration: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
